$( document ).ready(function() {
      
    $('.fb-right').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      fade: true,
      nextArrow: $('.next'),
      prevArrow: false,
      pauseOnHover: false,
      infinite: true
    });

  $('.fb-left-slider').slick({
      autoplay: true,
    autoplaySpeed: 5000,
      slidesToShow: 1,
      fade: true,
      nextArrow: $('.next'),
      prevArrow: false,
      asNavFor: $('.fb-right'),
    pauseOnHover: false,
      infinite: true
    });

  $('.number-slider').slick({
      autoplay: true,
    autoplaySpeed: 5000,
      slidesToShow: 1,
      fade: true,
      prevArrow: false,
    nextArrow: false,
    pauseOnHover: false,
      infinite: true
    
    });


 
         
  
    $('.modal-slider').slick({
      centerMode: false,
      autoplay: false,
      slidesToShow: 1,
      fade: true,
      arrows: true,
      prevArrow: $('.prev'),
      nextArrow: $('.next'),
      dots: false
    });

  
});